// @flow
import * as React from 'react';
import classNames from 'classnames';
import RModal from 'react-modal';
import styles from './Modal.module.scss';

type Props = {
    body: React.Node,
    bodyClassName?: string,
    contentLabel: string,
    footer: React.Node,
    footerClassName?: string,
    header: React.Node,
    headerClassName?: Object,
    large: boolean,
    leftImage: React.Node,
    medium: boolean,
    modalRightClassName?: string,
    modalSize: string,
    shouldReturnFocusAfterClose: boolean,
    show: boolean,
    small: boolean,
};

export default class Modal extends React.Component<Props> {
    static defaultProps = {
        body: null,
        footer: null,
        header: null,
        large: false,
        leftImage: null,
        medium: false,
        modalSize: '',
        shouldReturnFocusAfterClose: true, //this is the default of the library
        show: false,
        small: false,
    };

    // Do NOT add a shouldComponentUpdate method.  It will break the children

    render() {
        const {
            body,
            bodyClassName,
            contentLabel,
            footer,
            footerClassName,
            header,
            headerClassName,
            large,
            leftImage,
            medium,
            modalRightClassName,
            modalSize,
            shouldReturnFocusAfterClose,
            show,
            small,
        } = this.props;

        const classes = classNames(
            styles['modal-content'],
            { [styles['modal-content-large']]: large },
            { [styles['modal-content-medium']]: medium },
            { [styles['modal-content-small']]: small },
            { [modalSize]: modalSize },
            { [styles['modal-content-size']]: !large && !small && !modalSize }
        );

        const rightModalClasses = classNames(styles['modal-right'], modalRightClassName);

        const footerClasses = classNames(styles['modal-footer'], footerClassName);
        const bodyClasses = classNames(styles['modal-body'], bodyClassName || styles['modal-body-default']);
        const headerClasses = classNames(styles['modal-header'], headerClassName || styles['modal-header-default']);

        return (
            <RModal
                ariaHideApp
                className={{
                    afterOpen: styles['modal-content--after-open'] || '',
                    base: classes,
                    beforeClose: styles['modal-content--before-close'] || '',
                }}
                bodyOpenClassName={styles['ReactModal__Body--open']}
                closeTimeoutMS={100}
                contentLabel={contentLabel}
                isOpen={show}
                overlayClassName={{
                    afterOpen: styles['modal-overlay--after-open'] || '',
                    base: `${styles['modal-overlay']}`,
                    beforeClose: styles['modal-overlay--before-close'] || '',
                }}
                shouldFocusAfterRender
                shouldReturnFocusAfterClose={shouldReturnFocusAfterClose}
            >
                {leftImage && <div className={styles['modal-leftImage']}>{leftImage}</div>}
                <div className={rightModalClasses}>
                    {header && <div className={headerClasses}>{header}</div>}
                    {body && <div className={bodyClasses}>{body}</div>}
                    {footer && <div className={footerClasses}>{footer}</div>}
                </div>
            </RModal>
        );
    }
}
